
import { Component, Prop, Vue } from "vue-property-decorator";
import { Candidate } from "@/lib/model/exam/result";
import html2Pdf from "@/lib/html2pdf";
import { wait } from "@/lib/common/common";

type LinkConfig = {
  link: string;
  x: number;
  y: number;
  width: number;
  height: number;
};

@Component({})
export default class LowerRightCorner extends Vue {
  @Prop({ default: () => new Candidate() }) candidate!: Candidate;
  @Prop({ type: Boolean, default: false }) dataAllReady!: boolean; //数据是否加载完成
  pdfIng = false; //下载pdf中
  //是否已经完成评分
  get markOver() {
    return this.candidate.aiProcessStatus === 3;
  }
  //跳转
  toScroll(to: string) {
    const parent = this.$parent;
    if (parent) {
      if (!parent.$refs[to] || this.pdfIng) {
        return;
      }
      (parent.$refs[to] as HTMLElement).scrollIntoView({
        behavior: "smooth",
        block: "start"
      });
    }
  }

  setPdfIng(ing: boolean) {
    console.log("🚀 ~ LowerRightCorner ~ setPdfIng ~ ing:", ing);
    this.pdfIng = ing;
    this.$emit("setPdfIng", ing);
  }

  linkConfigList: LinkConfig[] = [];
  setPDFLink() {
    const anchorList = (document.querySelectorAll(
      ".pdf-video-anchor"
    ) as unknown) as HTMLElement[];
    if (!anchorList.length) return;
    this.linkConfigList = [];
    const headToDown = "vod2.hina.com";
    const headToPreview = "vod2.hina.com";
    anchorList.forEach(item => {
      let link = item.getAttribute("pdf-video-url");
      console.log("🚀 ~ LowerRightCorner ~ setPDFLink ~ link:", link);
      if (link) {
        if (link.includes(headToDown)) {
          link = link.replace(headToDown, headToPreview);
        }
        const rect = item.getBoundingClientRect();
        this.linkConfigList.push({
          link,
          x: rect.left,
          // y: rect.top ,
          y: item.offsetTop,
          width: rect.width,
          height: rect.height
        });
      }
    });
  }

  async downPDF() {
    if (this.pdfIng) return false;
    this.setPdfIng(true);
    await wait(1000);
    this.$nextTick(() => {
      const resultBox: HTMLElement = document.getElementById(
        "full"
      ) as HTMLElement;
      this.setPDFLink();
      html2Pdf.downloadPDF(
        resultBox,
        "AI面试报告-" + this.candidate.showName,
        false,
        this.linkConfigList,
        this.$route.query.autoDownload === "1"
      );
      setTimeout(() => {
        this.setPdfIng(false);
      }, 2000);
    });
  }
}
